import React from 'react'

export const Header = () => {
  return (
    <h2>
      Tracc - Personal Expense Tracker
    </h2>
  )
}
